/* ---------------------------------------------------------------
   Kuno · Naehrwertanzeige · 29.08.2026
   Laedt als LETZTE der Kuno-Dateien, nach kuno-anzeige.js.

   Alexander: "Bringe auch die anderen Werte dahin, dass die auch mit
   angezeigt werden und mit reinlaufen." Die Zahlen selbst traegt
   kuno-extra.js in NAEHRWERT nach - hier geht es nur darum, sie zu
   zeigen:

   1  Bei einem einzelnen Artikel steht die Naehrwerttabelle je 100 g
      oben in der rechten Spalte.
   2  Steht eine Naehrwertliste auf der Seite (Zucker, Eiweiss, Fett,
      Energie, Kohlenhydrate), traegt jede Karte ihre Zahl.

   Warum eine eigene Datei und kein Eingriff in kuno-anzeige.js: die
   Anzeigeschicht ist gross und geprueft. Zwei kleine Ergaenzungen
   lassen sich sauber davorhaengen, ohne sie noch einmal anzufassen.
   Faellt diese Datei aus, fehlen nur die Zahlen - sonst nichts.
   --------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.KUNO_NAEHRWERT) return;
  window.KUNO_NAEHRWERT = '2026-08-29';
  if (typeof NAEHRWERT === 'undefined') return;

  function zahl(n) { return String(n).replace('.', ','); }

  /* Reihenfolge wie auf der Packung, nach LMIV: Energie, Fett, davon
     gesaettigte Fettsaeuren, Kohlenhydrate, davon Zucker, Eiweiss,
     Salz. Wer die Tabelle vom Etikett kennt, findet sich sofort
     zurecht. */
  var ZEILE = [
    ['kcal', 'Energie', ' kcal'],
    ['fett', 'Fett', ' g'],
    ['gesaettigt', 'davon gesättigte Fettsäuren', ' g'],
    ['kohlenhydrate', 'Kohlenhydrate', ' g'],
    ['zucker', 'davon Zucker', ' g'],
    ['eiweiss', 'Eiweiß', ' g'],
    ['salz', 'Salz', ' g']
  ];

  function tabelle(liste) {
    /* Nur bei genau einem Artikel. Bei einer Liste waere die Tabelle
       entweder falsch oder eine Tapete. */
    if (!liste || liste.length !== 1) return '';
    var n = NAEHRWERT[liste[0].s];
    if (!n) return '';
    var teile = [];
    ZEILE.forEach(function (z) {
      if (n[z[0]] != null) teile.push(z[1] + ' ' + zahl(n[z[0]]) + z[2]);
    });
    if (teile.length < 3) return '';
    return '<div class="kuno-panel__info"><h3>Nährwerte je 100 g</h3><p>' +
           teile.join(' · ') + '. Angabe des Erzeugers vom Etikett.</p></div>';
  }

  if (typeof seitenspalte === 'function') {
    var altSpalte = seitenspalte;
    seitenspalte = function (result, liste) {
      altSpalte(result, liste);
      var html = tabelle(liste || []);
      var seite = document.getElementById('side');
      if (html && seite) seite.insertAdjacentHTML('afterbegin', html);
    };
  }

  /* Die Zahl auf der Karte. Ohne sie muesste man der Sortierung
     glauben, ohne sie nachlesen zu koennen. Die Marke setzt
     kuno-extra.js in pick() und loescht sie bei der naechsten Frage.

     Eingesetzt wird vor dem Preis - dieser Anker steht in jeder
     Karte, die kuno-anzeige.js baut. Findet er sich nicht, bleibt die
     Karte unveraendert statt kaputt. */
  var NAME = { kcal: 'kcal', zucker: 'g Zucker', eiweiss: 'g Eiweiß',
               fett: 'g Fett', kohlenhydrate: 'g Kohlenhydrate' };

  if (typeof karte === 'function') {
    var altKarte = karte;
    karte = function (p) {
      var html = altKarte(p);
      var stoff = window.kunoNaehrSpalte;
      if (!stoff || !NAEHRWERT[p.s] || NAEHRWERT[p.s][stoff] == null) return html;
      var anker = '<div class="ppreis">';
      if (html.indexOf(anker) < 0) return html;
      var zeile = '<div class="pnotiz">' + zahl(NAEHRWERT[p.s][stoff]) + ' ' +
                  (NAME[stoff] || stoff) + ' je 100 g</div>';
      return html.replace(anker, zeile + anker);
    };
  }
})();
